import { UmbracoTypes } from '~/lib/data-contract';
import { ProductList } from '~/features/ProductList';
import { useSKUResults } from '~/services/loop54/hooks';
import { ModuleContainer } from '../../shared/ModuleContainer';
import { ModuleHeader } from '../../shared/ModuleHeader';
import { useMedia } from 'react-use';
import { queries } from '~/theme';

export const M77SpecificProductNumbersGrid = ({
    headline,
    link,
    productNumbers,
    ...rest
}: UmbracoTypes.IM77SpecificProductNumbersGridModule) => {
    const isMobile = useMedia(queries.xs, true);
    const { data } = useSKUResults({ productNumbers, isMobile });

    return data?.results?.items?.length ? (
        <ModuleContainer hasGutter {...rest}>
            <ModuleHeader
                headlineText={headline}
                link={link}
                headlineVariant="display4"
            ></ModuleHeader>

            <ProductList items={data?.results?.items} itemListName={headline} isFullWidth />
        </ModuleContainer>
    ) : null;
};
